<template>
   <div>
        <v-card v-if="notShow" class="pa-2" tile="">
            <v-card-title>
                {{notTitle}} 
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="notHeaders"
                :items="notItems"
                :search="search" > 
                
                <template v-slot:top> 
                </template> 

                <template v-slot:item.candidate_name="{ item }" >  
                    <v-avatar
                        size="18"
                        :color="item.party_color?item.party_color:'primary s'"/> 
                    {{item.candidate_name}} 
                </template> 
                <template v-slot:item.action="{ item }" >  
                    <v-btn @click="view(item)" tile="" dark=""  :color="'primary'">View <v-icon class="pl-1 " dark="">mdi-eye</v-icon></v-btn>
                </template>
                <template v-slot:no-data>
                    <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                        <v-icon>warning</v-icon>
                        Empty
                    </v-layout>
                </template>
            </v-data-table> 
        </v-card>  
   </div>
</template>

<script>
let pageName = 'ResultsTeble'
export default {
    props:[ 'not','notShow','notItems','notHeaders',"notTitle" ],
    created(){   
    }, 
    data(){
        return{
            search: '',
            input:[]
        }
       
    },
    created(){
        this.EventBus.$on('notYesDialog', this.notYesDialog); 
    },
    mounted() {   
        this.pageLoad(1000)
    },
    computed:{
       //commony
        us(){
            return this.not.us
        },
        loading(){  
            return this.not.loading
        },
        processes(){  
            return this.not.processes
        }, 
        responses(){  
            return this.not.responses
        },
        /////////
    
    },
    methods:{
        notYesDialog(action){
            if (action) {
                if (action.code ===pageName+'=ADD-RESULT') {
                     
                }  
            }
        }, 
        view(item){
            this.$emit("viewItem",item)  
        },
        //-----------------[PAGE CONTRAL]---------
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/results'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/results'
                        })  
                        let updating = ps.find(process=>{
                            return process.name == 'updating/results'
                        })  
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/result'
                        }) 
                        let setting = ps.find(process=>{
                            return process.name == 'setting/results'
                        }) 

                        if (logging) {
                            this.page_show =false
                        }else{ 
                            this.page_show =true
                        }

                        if (getting) {
                            this.not.notDialogP(true,true,'updating...')
                        }else{
                            this.not.notDialogP(false)
                        }

                        
                        if (adding) {
                            this.not.notDialogP(true,true,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }  
                        if (updating) {
                            this.not.notDialogP(true,true,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }  
                        if (deleting) {
                            this.not.notDialogP(true,true,'Deleting...') 
                        }else{ 
                        }  

                        if (setting) {
                            this.not.notDialogP(true,true,'Uploading...')
                            this.input.loading = true
                        }else{ 
                        }  
                    }else{
                        this.page_show =true
                    }

                    //check response
                    if (res.res==='adding/results/successful') { 
                        this.not.notDialog(true,true,'Successful','result successfully added.','','OK',{code:pageName+'=ADD-RESULTS-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='adding/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding the result. make sure your password is correct or contact admin','','OK',{code:pageName+'=ADD-RESULTS-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 


                     if (res.res==='updating/results/successful') { 
                        this.not.notDialog(true,true,'Successful','result successfully edited.','','OK',{code:pageName+'=EDIT-RESULTS-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='updating/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while editing the result. make sure your password is correct or contact admin','','OK',{code:pageName+'=EDIT-RESULTS-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                     
                    if (res.res==='deleting/results/successful') { 
                        this.not.notDialog(true,true,'Successful','result successfully deleted.','','OK',{code:pageName+'=DELETE-RESULTS-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='deleting/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting the result. make sure your password is correct or contact admin','','OK',{code:pageName+'=DELETE-RESULTS-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                    if (res.res==='setting/results/successful') { 
                        this.not.notDialog(true,true,'Successful','results successfully upload.','','OK',{code:pageName+'=SETTING-RESULTS-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                        this.dialog_selected_results = false
                    }else if (res.res==='setting/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while uploading the results. ','','OK',{code:pageName+'=SETTING-RESULTS-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                        this.dialog_selected_results = false
                    } 
 
                },t)
            }
    },
    watch:{
        us(v){
                
        },
        loading(value){
            this.pageLoad(1)
        },
        processes(value){
            this.pageLoad(1)
        },
        responses(value){
            this.pageLoad(1) 
        } 
    } 
}
</script>
